// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"627":"f928b47b","799":"5cc3ab50","848":"720b00ce"}[chunkId] + ".chunk.css";
};